// App.js — refonte T0 (Lot 2).
// Rôle minimal : découverte dynamique des pages (require.context) + routage.
// Toute la « chrome » (sidebar, topbar, dark mode, recherche, redimensionnement) est dans PageShell.
// L'accueil est rendu par HomeGrid. Le hack `isIAPage`/`ia-page-container` (forçage dark) est SUPPRIMÉ
// au profit d'un dark mode uniforme via la classe `.dark` (tailwind darkMode:'class').
import React, { useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import PageShell from './components/doc/PageShell';
import HomeGrid from './components/doc/HomeGrid';

// Découverte dynamique des pages (mécanisme conservé).
const pageModules = require.context('./pages', true, /\.js$/);

// Construit l'arbre de navigation { dossier/fichier -> élément React } à partir des chemins.
function buildTree() {
  const tree = {};
  pageModules.keys().forEach((fileName) => {
    const parts = fileName.replace('./', '').replace('.js', '').split('/');
    let current = tree;
    parts.forEach((part, index) => {
      if (!current[part]) {
        current[part] = index === parts.length - 1
          ? React.createElement(pageModules(fileName).default)
          : {};
      }
      current = current[part];
    });
  });
  return tree;
}

const AppRoutes = ({ tree }) => {
  const navigate = useNavigate();
  return (
    <Routes>
      <Route path="/" element={<HomeGrid tree={tree} onNavigate={navigate} />} />

      {pageModules.keys().map((fileName) => {
        const path = `/${fileName.replace('./', '').replace('.js', '').toLowerCase()}`;
        const Component = pageModules(fileName).default;
        return (
          <Route
            key={path}
            path={path}
            element={
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                <Component />
              </motion.div>
            }
          />
        );
      })}

      <Route
        path="*"
        element={
          <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
            <h2 className="text-2xl font-bold text-gray-600 dark:text-gray-400">Page introuvable</h2>
            <p className="mt-2 text-gray-500 dark:text-gray-400">
              La page demandée n'existe pas ou a été déplacée.
            </p>
          </div>
        }
      />
    </Routes>
  );
};

const App = () => {
  const tree = useMemo(buildTree, []);
  return (
    <Router>
      <PageShell tree={tree}>
        <AppRoutes tree={tree} />
      </PageShell>
    </Router>
  );
};

export default App;
